module.exports = {
	acceptStatement: true,

	/**
	 * Sets a click handler on the directive's element, also sets the
	 * currentHandler instance property (so that unbind can use off() to
	 * remove the click handler)
	 */
	bind(el, binding) {
		const { modifiers, value: promise } = binding;

		const currentHandler = async function (event) {
			if (event && modifiers && modifiers.prevent) {
				event.preventDefault();
			}

			// request already started
			if (el.dataset.pending === 'true') {
				return;
			}

			el.dataset.pending = 'true';
			el.classList.add('-in-progress');

			const clearPending = () => {
				el.classList.remove('-in-progress');
				el.dataset.pending = undefined;
			};

			try {
				await promise();
			} catch (e) {
				clearPending();
				throw e;
			}

			clearPending();
		};

		el.progressClickHandler = currentHandler;
		el.addEventListener('click', el.progressClickHandler);
	},

	/**
	 * Removes the click handler from the element as Vue.js unbinds the directive
	 */
	unbind(el) {
		if (el.progressClickHandler) {
			el.removeEventListener('click', el.progressClickHandler);
			el.progressClickHandler = null;
		}
	}
};
